export default __webpack_public_path__ + "static/media/spa-image-02.b34ac1c7.jpg";